<section class="content-dialog">
    <div class="content-text">
        <div>
            <p> <span class="question"> {{ "CREDIT.dialog.leasingTitle" | translate }} </span> {{ "CREDIT.dialog.leasingText" | translate }}</p>
        </div>
        <div class="content-button">
            <button class="btn btn-action" (click)="goLeasing()" mat-button id="boton-select-leasing-renting{{templateSuffix !== '' ? '-b' : ''}}">
                {{ "CREDIT.dialog.leasingButton" | translate }}
            </button>
        </div>
    </div>
    <div class="content-text">
        <div>
            
            <p> <span class="question"> {{ "CREDIT.dialog.creditTitle" | translate }} </span> {{ "CREDIT.dialog.creditText" | translate }}</p>
        </div>
        <div class="content-button">
            <button class="btn btn-action" (click)="goCredit()" mat-button id="boton-select-credito{{templateSuffix !== '' ? '-b' : ''}}">
                {{ "CREDIT.dialog.creditButton" | translate }}
            </button>
        </div>
    </div>
</section>
  
